import React from 'react';
import Joi from 'joi';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useFieldset, useAsyncSubmit } from 'controls/hooks';
import UserContainer from 'components/user/container/UserContainer';
import { Button } from 'components/atoms/Button/Button';
import { Input } from 'components/atoms/Input/Input';
import { Header } from 'components/atoms/Header/Header';
import { editUser } from 'actions/user';
import { Language } from 'language/Language';
import { strings } from './strings';

const editForm = {
  name: '', email: '', password: '', newPassword: '', newPassword2: '',
};

const editSchema = {
  name: Joi.string().label('name'),
  email: Joi.string().max(50).label('email'),
  password: Joi.string().label('password').max(30).allow('').max(30).min(6),
  newPassword: Joi.string().label('newPassword').max(30).allow('').max(30).min(6),
  newPassword2: Joi.string().label('newPassword2').max(30).allow('').valid(Joi.ref('newPassword')).max(30).min(6).messages({ 'any.only': 'Confirmation password must be the same as the password' }),
};

const EditUser = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userInfo, siteInfo } = useSelector((state) => state);
  const { isWorking } = siteInfo;
  const language = Language();

  const onSubmit = async (data) => dispatch(editUser(data, history));

  if (userInfo) {
    editForm.name = userInfo.displayName;
    editForm.email = userInfo.email;
  }

  const {
    fields: {
      name,
      email,
      password,
      newPassword,
      newPassword2,
    }, submit,
  } = useFieldset({
    schema: editSchema,
    source: editForm,
    onSubmit: useAsyncSubmit(onSubmit),
  });

  return (
    <UserContainer>
      <form style={{ width: '100%' }} onSubmit={submit}>
        <div className='input-container'>
          <label>{strings[language].name}</label>
          <Input classes='input' field={name} />
        </div>
        <div className='input-container'>
          <label>{strings[language].email}</label>
          <Input classes='input' field={email} disable />
        </div>
        {userInfo.providerData[0].providerId === 'password'
          && (
            <>
              <Header text={strings[language].hero} />
              <div className='input-container'>
                <label>{strings[language].password}</label>
                <Input classes='input' type='password' field={password} isPassword />
              </div>
              <div className='input-container'>
                <label>{strings[language].newPassword}</label>
                <Input classes='input' type='password' field={newPassword} isPassword />
              </div>
              <div className='input-container' style={{ marginTop: '0' }}>
                <label>{strings[language].confirmPassword}</label>
                <Input classes='input' type='password' field={newPassword2} isPassword />
              </div>
            </>
          )}
        <Button
          isWorking={isWorking}
          text={strings[language].button}
          type='submit'
        />
      </form>
    </UserContainer>
  );
};

export default EditUser;
